import { authAPI } from './auth_api';
const Config = require('../conf');

const pageSize = 10;

export const servicesAPI = {
  BillingServices
};

function BillingServices(...params) {
  console.debug('BillingServices called with params:', params);

  if (params[0] === 'getAonHostStatement') {
    console.debug(
      'BillingServices: Getting AON host statement for account ID:',
      params[1]
    );
    const requestOptions = { method: 'GET', headers: authAPI.authHeader() };
    return fetch(
      Config.Local().billing_url + `/portal/aon/account/${params[1]}/statement`,
      requestOptions
    ).then(authAPI.handleResponse);
  }

  if (params[0] === 'getAccountByCustomerId') {
    console.debug(
      'BillingServices: Getting AON account for customer ID:',
      params[1]
    );
    const requestOptions = { method: 'GET', headers: authAPI.authHeader() };
    return fetch(
      Config.Local().billing_url + `/portal/aon/account/customer/${params[1]}`,
      requestOptions
    )
      .then(authAPI.handleResponse)
      .then(response => {
        if (response) {
          console.debug(
            'BillingServices: AON Account:',
            JSON.stringify(response)
          );
          return response;
        } else {
          console.debug(
            'BillingServices: Error: No response when getting AON account'
          );
        }
      })
      .catch(error => {
        console.error('BillingServices: Error getting AON account:', error);
        throw error;
      });
  }
}
